import { ListTenantUsersRequestSchema, ListTenantUsersResponseSchema } from './list-tenant-users.schema';
/**
 * List Tenant Users Endpoint Contract
 * Retrieves all non-deleted users for a specific tenant (super-admin only)
 */ export const listTenantUsersContract = {
    method: 'GET',
    path: '/api/v2/tenants/:tenantId/users',
    description: 'Retrieve all non-deleted users for a specific tenant',
    requestSchema: ListTenantUsersRequestSchema,
    responseSchema: ListTenantUsersResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin',
            404: 'Tenant not found'
        }
    }
};

//# sourceMappingURL=list-tenant-users.contract.js.map